//import '../classes/EventedClass'

export default class base extends EventedClass{
    constructor() {
        super();
    }
}